export default class ProcessadorAtribuicao {
    constructor({ mapaOperandos, mapaCondicoes }) {
        this.mapaOperandos = mapaOperandos;
        this.mapaCondicoes = mapaCondicoes;
    }

    async avaliarCondicao({ atribuicao, dados }) {
        if (!atribuicao.condicao) {
            return true;
        }
        let tipoCond = atribuicao.condicao.tipo;
        let processadorCondicao = this.mapaCondicoes[tipoCond];
        let avaliacao = await processadorCondicao.avaliar({
            dados,
            condicao: atribuicao.condicao,
        });
        return avaliacao;
    }

    async atribuirValor({ atribuicao, dados, atribuicoes }) {
        let tipoOp = atribuicao.operando.tipo;
        let processadorOperando = this.mapaOperandos[tipoOp];
        let valor = await processadorOperando.calcularValor({
            operando: atribuicao.operando,
            dados,
            atribuicoes,
        });

        atribuicoes[atribuicao.propriedade] = valor;
    }

    async processar({ atribuicao, dados, atribuicoes }) {
        const avaliacao = await this.avaliarCondicao({ atribuicao, dados });
        if (avaliacao) {
            await this.atribuirValor({ atribuicao, dados, atribuicoes });
        }
    }
}
